import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { register } from "../api/menupro.api";
import { setBusiness } from "../store/menupro.store";
import "./auth.css";

export default function Register() {
    const [businessName, setBusinessName] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleRegister = async () => {
        if (!businessName || !phone || !password) {
            alert("Bütün xanaları doldurun");
            return;
        }

        try {
            await register({ businessName, phone, password });
            // artıq OTP gedib, verify-ə keçirik
            navigate(`/menupro/verify?phone=${encodeURIComponent(phone)}&password=${encodeURIComponent(password)}`);
        } catch {
            alert("Bu nömrə artıq qeydiyyatdan keçib");
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h1 className="auth-title">MenuPro</h1>
                <p className="auth-subtitle">Biznes hesabı yarat</p>

                <input
                    className="auth-input"
                    placeholder="Biznes adı"
                    value={businessName}
                    onChange={(e) => setBusinessName(e.target.value)}
                />

                <input
                    className="auth-input"
                    placeholder="Telefon nömrəsi"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />

                <input
                    className="auth-input"
                    type="password"
                    placeholder="Şifrə"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button className="auth-button" onClick={handleRegister}>
                    Qeydiyyatdan keç
                </button>

                <p className="auth-link">
                    Artıq hesabın var? <Link to="/menupro/login">Daxil ol</Link>
                </p>
            </div>
        </div>
    );
}

